export const PRE_ROLL = 'preRoll'
export const MID_ROLL = 'midRoll'
export const EPISODE = 'episode'
export const NONE = 'none'



// WEBPACK FOOTER //
// ./src/components/AudioPlayer/model/constants/ObjectType.js